<template>
  <b-card>
    <FormBuilder
      label="Kategori"
      create
      :fields="fields"
      :loading-submit="$store.state.category.loadingSubmit"
      @submit="submitData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    submitData(data, callback) {
      this.$store.dispatch('category/create', data)
        .then(callback)
    },
  },
}
</script>

<style scoped>

</style>
